import { PostEndImpersonation } from "@/server-types";
import { useCustomMutation } from "../custom-mutation";
import { post } from "../request-helpers";

export const useEndImpersonation = () => {
  return useCustomMutation({
    mutationFn: () => post<PostEndImpersonation>(`/impersonation/end`, {}),
  });
};
